import axios from 'axios';
import { ensureCsrfToken } from '../utils/csrf';
import { logAPI, logError } from '../utils/logger';

const MUTATING_METHODS = new Set(['post', 'put', 'patch', 'delete']);

const apiClient = axios.create({
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
});

// Request interceptor - adds CSRF token and logs requests
apiClient.interceptors.request.use(async (config) => {
  const startTime = Date.now();
  config.metadata = { startTime };

  const method = (config.method || '').toLowerCase();
  if (MUTATING_METHODS.has(method)) {
    const csrfToken = await ensureCsrfToken();
    if (csrfToken) {
      config.headers = {
        ...config.headers,
        'X-CSRF-Token': csrfToken,
      };
    }
  }

  // Log the request
  logAPI(
    config.method,
    config.url,
    config.data,
    null,
    null
  );

  return config;
}, (error) => {
  logError('API Request Error', error, { url: error.config?.url });
  return Promise.reject(error);
});

// Response interceptor - logs responses
apiClient.interceptors.response.use(
  (response) => {
    const duration = Date.now() - (response.config.metadata?.startTime || Date.now());

    // Log the response
    logAPI(
      response.config.method,
      response.config.url,
      null,
      response,
      duration
    );

    return response;
  },
  (error) => {
    const duration = Date.now() - (error.config?.metadata?.startTime || Date.now());

    // Log the error
    logError('API Error', error, {
      method: error.config?.method,
      url: error.config?.url,
      status: error.response?.status,
      duration: `${duration}ms`
    });

    return Promise.reject(error);
  }
);

export default apiClient;
